import { useNavigate } from 'react-router-dom';

// import styled from '@emotion/styled';

import EmptyableCard from '../../../../components/Card/EmptyableCard';
import PostedJobsCard from '../../../../components/Card/PostedJobsCard';
// import { MoreHorizontal } from '../../../../components/Icons/MoreHorizontal';
import { useAppSelector } from '../../../../redux/store';
import { APPLICATION } from '../../../../routes/routeConstants';

// const DummyPostedJobs = [
//   {
//     imgSrc: '/static/gif/happyAnimal.gif',
//     title: 'Pharmacist',
//     description:
//       'Join our General Medicine SHO Position in Lagos: Elevate Your Career, Impact Patient Care',
//     contractDuration: 'Mar 10th, 2023 - July 26th, 2023',
//     pay: 10000,
//   },
//   {
//     imgSrc: '/static/gif/happyAnimal.gif',
//     title: 'Pharmacist',
//     description:
//       'Join our General Medicine SHO Position in Lagos: Elevate Your Career, Impact Patient Care',
//     contractDuration: 'Mar 10th, 2023 - July 26th, 2023',
//     pay: 10000,
//   },
//   {
//     imgSrc: '/static/gif/happyAnimal.gif',
//     title: 'Pharmacist',
//     description:
//       'Join our General Medicine SHO Position in Lagos: Elevate Your Career, Impact Patient Care',
//     contractDuration: 'Mar 10th, 2023 - July 26th, 2023',
//     pay: 10000,
//   },
//   {
//     imgSrc: '/static/gif/happyAnimal.gif',
//     title: 'Pharmacist',
//     description:
//       'Join our General Medicine SHO Position in Lagos: Elevate Your Career, Impact Patient Care',
//     contractDuration: 'Mar 10th, 2023 - July 26th, 2023',
//     pay: 10000,
//   },
// ];
const YourPostedJobs = () => {
  const navigate = useNavigate();

  const activejobsList = useAppSelector((state) => state.activeJobsList);

  const activejobs = activejobsList.jobData;

  const handleViewAll = () => {
    navigate(`/${APPLICATION}`);
  };

  return (
    <EmptyableCard
      label="Active Jobs"
      // viewAll={
      //   <Linkk to="/u/dashboard/view-all-posted-jobs">
      //     <MoreHorizontal />
      //   </Linkk>
      // }
      viewAllClick={handleViewAll}
      emptyViewNote="You currently do not have any listing,
verify your account to get started"
      // isEmpty={activejobs.length === 0}
      // emptygif="/static/gif/manBigleans.gif"
    >
      {activejobs.map((data, index) => (
        <PostedJobsCard
          key={index}
          title={data.title}
          description={data.jobDescription}
          startDate={data.jobStartDate}
          endDate={data.jobEndDate}
          pay={data.pay}
          payInterval={data.payInterval}
        />
      ))}
    </EmptyableCard>
  );
};

export default YourPostedJobs;

// const Linkk = styled(Link)`
//   text-decoration: none;
//   color: ${({ theme }) => theme.palette.greyGrey2};
// `;
